export const facebookShareURL = (absoluteURL: string) => {
  return `https://www.facebook.com/sharer/sharer.php?u=${absoluteURL}`;
};

export const lineShareURL = (absoluteURL: string) => {
  return `https://line.me/R/msg/text/?${absoluteURL}`;
};
